import { Flex, FlexProps, Image, ImageProps } from 'rebass';
import React from 'react';

type UploadPreviewProps = {
  file?: File;
  previewUrl?: string;
  iframeProps?: Omit<JSX.IntrinsicElements['iframe'], 'src'>;
} & FlexProps;

const UploadPreview: React.FC<UploadPreviewProps> = (props) => {
  const { file, previewUrl, iframeProps, ...flexProps } = props;
  return (
    <>
      {file && previewUrl && (
        <Flex
          {...(flexProps as any)}
          sx={{
            p: 0,
            bg: 'white',
            flexGrow: 1,
            flexDirection: 'column',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            justifyItems: 'center',
            flexShrink: 1,
            backgroundImage:
              file.type.startsWith('image/') && previewUrl
                ? `url('${previewUrl}')`
                : undefined,
            backgroundColor: file.type.startsWith('image/')
              ? '#111'
              : undefined,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            backgroundPosition: 'center center',
            borderRadius: 'defaultNested',
            color: 'primary',
            height: '100%',
            width: '100%',
            maxHeight: '100%',
            maxWidth: '100%',
            cursor: 'pointer',
            overflow: 'hidden',
            wordBreak: 'break-all',
            textDecoration: 'none',
            ...flexProps.sx,
          }}
        >
          {file.type.startsWith('image/') &&
            file.name?.toLowerCase().endsWith('.heic') && <>{file.name}</>}
          {!file.type.startsWith('image/') && (
            <>
              {!file.type.endsWith('/pdf') && (
                <Flex
                  alignContent="center"
                  alignItems="center"
                  justifyContent="center"
                  flexGrow={1}
                  flexShrink={1}
                  sx={{
                    wordBreak: 'break-all',
                  }}
                >
                  {file.name}
                </Flex>
              )}
              {file.type.endsWith('/pdf') && (
                <iframe
                  frameBorder={0}
                  height="100%"
                  width="100%"
                  {...iframeProps}
                  style={{
                    padding: 0,
                    border: 'none',
                    pointerEvents: 'none',
                    ...iframeProps?.style,
                  }}
                  src={previewUrl + '#view=FitV&toolbar=0'}
                />
              )}
            </>
          )}
        </Flex>
      )}
    </>
  );
};

export default UploadPreview;
